import axios from 'axios';
import { getImpersonationHeader } from '../util';
import { authorize } from '../../AWS';
import { apiGatewayBaseUrl } from '../services';

// Private Instance
const privateInstance = axios.create({
  baseURL: apiGatewayBaseUrl,
});

privateInstance.interceptors.request.use(async (config) => {
  const authorization = await authorize();
  if (!authorization) {
    return Promise.reject(new Error('Login again'));
  }

  config.headers = {
    'Content-Type': config.data instanceof FormData ? 'multipart/form-data' : 'application/json',
    Authorization: authorization,
    ...getImpersonationHeader(),
  };

  if (config.useBlob) {
    config.responseType = 'blob';
    config.headers = {
      ...config.headers,
      Accept: 'image/jpeg',
    };
  }

  return config;
});

privateInstance.interceptors.response.use(
  (response) => {
    if (response.config.responseType === 'blob') {
      return new Blob([response.data], {
        type: response.headers['content-type'],
      });
    } else {
      return response.data;
    }
  },
  (error) => {
    // We want to return timeout if there is ERR_NETWORK error code
    // due to timeout or bad connection to inform users to check back if applicable
    if (error.code === 'ERR_NETWORK') {
      error.response = {
        data: {
          timeout: true,
        },
      };
    }

    return Promise.reject(error.response);
  },
);

export { privateInstance };
